import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_shape",
  "use": "icon-ic_shape-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-ic_shape\"><path d=\"M14 0C6.278 0 0 6.283 0 14s6.283 14 14 14 14-6.283 14-14S21.717 0 14 0zm2.155 20.464c0 1.189-.97 2.157-2.156 2.157a2.163 2.163 0 0 1-2.156-2.157v-6.463a2.16 2.16 0 0 1 2.156-2.156c1.186 0 2.156.97 2.156 2.156v6.463zM14 9.69a2.161 2.161 0 0 1-2.156-2.157c0-1.186.97-2.156 2.156-2.156 1.186 0 2.156.97 2.156 2.156 0 1.187-.97 2.157-2.156 2.157z\" fill=\"#6EACE2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol